import React from 'react';

/**
 * Componente de input reutilizable con label, icono y manejo de errores
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.label - Texto del label
 * @param {string} props.icon - Nombre del icono FontAwesome (sin prefijo "fa-")
 * @param {string} [props.type='text'] - Tipo de input
 * @param {string} props.name - Nombre e id del input
 * @param {string} props.value - Valor del input
 * @param {Function} props.onChange - Handler de cambio
 * @param {string} [props.error] - Mensaje de error a mostrar
 * @param {string} [props.placeholder] - Placeholder del input
 * @param {boolean} [props.disabled] - Si el input está deshabilitado
 * @returns {JSX.Element}
 */
function FormInput({
  label,
  icon,
  type = 'text',
  name,
  value,
  onChange,
  error,
  placeholder,
  disabled
}) {
  return (
    <div className="form-group">
      <label htmlFor={name} className="form-label">
        <i className={`fas fa-${icon}`}></i> {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      {error && (
        <div className="invalid-feedback">
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
      )}
    </div>
  );
}

export default FormInput;
